import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { farmhouseData } from '../data/mockData';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goToAnchor = (id) => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: id } });
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-studio">
      <div className="footer-cta">
        <div className="edge wrap">
          <span className="label">Ready When You Are</span>
          <div className="footer-cta-row">
            <h2 className="footer-cta-title">
              Let&rsquo;s get<br />you booked.
            </h2>
            <div style={{ display: 'flex', gap: '0.85rem', flexWrap: 'wrap' }}>
              <a
                href="https://wa.me/918008002388?text=Hi,%20I'm%20interested%20in%20booking%20Leoland%20by%20VengaFarms"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-accent"
              >
                WhatsApp Us <ArrowUpRight size={16} />
              </a>
              <a href="tel:+918008002388" className="btn btn-line-dark">
                +91 80080 02388
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="edge">
        <div className="wrap footer-columns">
          <div>
            <div className="footer-col-title">Leoland by VengaFarms</div>
            <p className="copy" style={{ maxWidth: '320px' }}>
              A black container villa with a private pool, set inside Leonia
              Resorts, Shamirpet &mdash; designed for groups who want a proper
              getaway.
            </p>
          </div>
          <div>
            <div className="footer-col-title">Explore</div>
            <div className="footer-links">
              <a onClick={() => goToAnchor('specifications')}>Amenities</a>
              <a onClick={() => goToAnchor('rates')}>Rates</a>
              <a onClick={() => goToAnchor('availability')}>Availability</a>
              <a onClick={() => navigate('/gallery')}>Gallery</a>
            </div>
          </div>
          <div>
            <div className="footer-col-title">Property</div>
            <div className="footer-links">
              <a onClick={() => goToAnchor('location')}>Getting Here</a>
              <a onClick={() => goToAnchor('rules')}>House Rules</a>
              <a onClick={() => goToAnchor('faq')}>FAQ</a>
              <a onClick={() => goToAnchor('testimonials')}>Reviews</a>
            </div>
          </div>
          <div>
            <div className="footer-col-title">Contact</div>
            <div className="footer-links">
              <a href="tel:+918008002388">+91 80080 02388</a>
              <a href="https://wa.me/918008002388" target="_blank" rel="noopener noreferrer">WhatsApp</a>
              <span style={{ color: 'var(--text-dark-3)', fontSize: '0.9375rem' }}>
                {farmhouseData.location.address}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="edge">
        <div className="wrap footer-bottom">
          <span>&copy; 2026 Leoland by VengaFarms</span>
          <span>Plot 429, Leonia Resorts, Shamirpet, Hyderabad</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
